// Getters
export const PRTR_IS_ERROR = 'partner/statePrtrIsError';
export const PRTR_IS_LOADING = 'partner/statePrtrIsLoading';
export const PRTR_GET_DATA = 'partner/statePrtrData';

//Mutations

// Actions
export const PRTR_ACTION_GET_DATA = 'partner/statePrtrGetData';



// WEBPACK FOOTER //
// ./src/store/types_partner.js